<div class="drawer-content">
    <ng-container *ngIf="isLoading">
      <div class="loading-container">
        <nz-spin nzTip="Loading..."></nz-spin>
      </div>
    </ng-container>
  
    <ng-container *ngIf="error">
      <nz-alert nzType="error" [nzMessage]="error" nzShowIcon></nz-alert>
    </ng-container>
  
    <ng-container *ngIf="!isLoading && !error && submissionDetails">
      <div class="post-details-section">
       <br />       
        <nz-descriptions nzBordered [nzColumn]="1" nzSize="small">
          <nz-descriptions-item *ngIf="submissionDetails.authorName != null" nzTitle="Posted by">{{ submissionDetails.authorName }}</nz-descriptions-item>
          <nz-descriptions-item nzTitle="Created at">{{ formatDatetime(submissionDetails.createdAt.toString()) }}</nz-descriptions-item>
          <nz-descriptions-item nzTitle="Subreddit">r/{{ submissionDetails.subName }}</nz-descriptions-item>
          <nz-descriptions-item nzTitle="Mentioned Politician">{{ submissionDetails.politicianName }}</nz-descriptions-item>
          <nz-descriptions-item nzTitle="Submission Content">
            <div class="post-text">{{ submissionDetails.title }}</div>
          </nz-descriptions-item>
          
          <nz-descriptions-item nzTitle="Submission URL">
            <a [href]="submissionDetails.url" target="_blank">
              {{ submissionDetails.url }} &nbsp;
              <fa-icon [icon]="faExternalLink"></fa-icon>
            </a>
          </nz-descriptions-item>
          
          <nz-descriptions-item nzTitle="Upvotes">
            <nz-tag [nzColor]="'blue'"  nz-tooltip nzTooltipTitle="Upvotes">
              <i nz-icon nzType="like" nzTheme="outline"></i> {{ submissionDetails.score }}
            </nz-tag>
          </nz-descriptions-item>
  
          <nz-descriptions-item nzTitle="Topic" *ngIf="submissionDetails.topicName">{{ submissionDetails.topicName }}</nz-descriptions-item>
        
        </nz-descriptions>
      </div>
    </ng-container>

    <ng-container *ngIf="submissionDetails?.id != null">
      <app-reddit-comments [submissionId]="submissionDetails?.id"></app-reddit-comments>
    </ng-container>
  
    <div class="drawer-footer">
      <button nz-button nzType="primary" (click)="close()">Close</button>
    </div>
  </div>